import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  onGetUsers
} from '../../../config/redux/slice/appSlice'
import { getRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'
import { DigitalLetterWrapper } from '../../components'
import DigitalLetterCompose from './DigitalLetterCompose'
import DigitalLetterDraftMain from './DigitalLetterDraftMain'
import DigitalLetterInboxMain from './DigitalLetterInboxMain'
import DigitalLetterSentMain from './DigitalLetterSentMain'

export default function DigitalLetter() {
  const dispatch = useDispatch()
  const {

        digitalLetterManagement:{activeEmailTab},
        userManagement: {usersData}
    } = useSelector((state) => state.app)


    const {
        token
    } = useSelector((state) => state.authData)

    useEffect(()=>{
      getUsers()
    }, [])

  const getUsers = async () =>{
      const res = await getRequest(
        token,
        `${appApi.getUsers}`,
        {},
        dispatch,
        "",
        onGetUsers,
        ""
      )

  }
  return (
    <DigitalLetterWrapper>
      {activeEmailTab == 'compose' ?
      <DigitalLetterCompose/> : activeEmailTab == 'draft' ?
      <DigitalLetterDraftMain/> : activeEmailTab == 'sent' ?
      <DigitalLetterSentMain/> :
       <DigitalLetterInboxMain/>}
        {/* <DigitalLetterCompose/> */}
        {/* <DigitalLetterDetails/> */}
     </DigitalLetterWrapper>   
  )
}
